import defaultSignature from "../assets/images/signature.png";

export const DEFAULT_CLINICIAN_SIGNATURE = defaultSignature;
export const DEFAULT_CLINICIAN_GMC = "7280928";
export const DEFAULT_CLINICIAN_FIRST_NAME = "Sunil";
export const DEFAULT_CLINICIAN_LAST_NAME = "Hathi";